import React from "react";
import Background from "../templates/Background";
import MainContent from "../organisms/MainContent";
var GovernanceDemoPage = function () {
    return (React.createElement(Background, { title: "DATA GOVERNANCE", subtitle: "Use the Admin, Marketing and Customer Support tabs below to learn about Skyflow's data governance features.", body: MainContent }));
};
export default GovernanceDemoPage;
